<template>
  <div class="mt-2.5 xl:mt-5" :class="parentClass">
    <div
      v-for="(des, index) in useTerm"
      :key="index"
      class="lg:gap-4 md:gap-3 flex gap-2 text-text-primary-light-grey font-poppins font-normal lg:text-base lg:leading-8 leading-6 text-sm opacity-100 items-baseline mb-3"
    >
      <div :class="[`bg-how-it-work-btn-${index + 1}`]" class="rounded-full">
        <div
          class="w-4 h-4 lg:h-6 lg:w-6 text-xs lg:text-xs flex items-center justify-center text-white"
        >
          {{ index + 1 }}
        </div>
      </div>
      <span :class="childClass">
        {{ $t(`landingPage.${des}`) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Policy',

  props: {
    useTerm: { type: String, default: '' },
    parentClass: { type: String, default: '' },
    childClass: { type: String, default: '' },
  },
  data() {
    return {
      landingPage: 'landingPage',
    }
  },
}
</script>

<style scoped>
.bg-how-it-work-btn-1 {
  background: transparent linear-gradient(213deg, #ffc870 0%, #f7a92b 100%) 0% 0%;
  box-shadow: 1px 1px 12px #ffa7193b;
}
.bg-how-it-work-btn-2 {
  background: transparent linear-gradient(214deg, #8dbfff 0%, #4e8ddd 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #196dff3b;
}
.bg-how-it-work-btn-3 {
  background: transparent linear-gradient(207deg, #c3b6fb 0%, #9983fc 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #8419ff3b;
}
.bg-how-it-work-btn-4 {
  background: transparent linear-gradient(213deg, #75ff90 0%, #61d978 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #19ff843b;
}

.bg-how-it-work-btn-5 {
  background: transparent linear-gradient(213deg, #d8e443 0%, #afb83b 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #9ec7863b;
}
.bg-how-it-work-btn-6 {
  background: transparent linear-gradient(213deg, #ff8982 0%, #f94f46 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #fd98ba3b;
}
.bg-how-it-work-btn-7 {
  background: transparent linear-gradient(207deg, #c3b6fb 0%, #9983fc 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #8419ff3b;
}
.bg-how-it-work-btn-8 {
  background: transparent linear-gradient(213deg, #d8e443 0%, #afb83b 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #9ec7863b;
}
</style>